"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphStyleExporter = void 0;
var tslib_1 = require("tslib");
var style_base_1 = require("./style-base");
var ParagraphStyleExporter = (function (_super) {
    tslib_1.__extends(ParagraphStyleExporter, _super);
    function ParagraphStyleExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphStyleExporter.prototype.getStyleId = function (styleIndex) {
        return 'P' + styleIndex.toString();
    };
    ParagraphStyleExporter.prototype.getStyleIndexByName = function (name) {
        return this.data.model.stylesManager.paragraphStyleNameToIndex[name];
    };
    ParagraphStyleExporter.prototype.getType = function () { return 'paragraph'; };
    ParagraphStyleExporter.prototype.exportCore = function (style) {
        if (style.nextParagraphStyle != null)
            this.writer.writeWpStringValue('next', this.getStyleId(this.getStyleIndexByName(style.nextParagraphStyle.styleName)));
        if (style.linkedStyle)
            this.writer.writeWpStringValue('link', this.getStyleId(this.data.charStyleExporter.getStyleIndexByName(style.linkedStyle.styleName)));
        if (style.autoUpdate)
            this.writer.writeWpBoolValue('autoRedefine', style.autoUpdate);
        this.data.parPropsExporter.exportStyleParagraphProperties(style.maskedParagraphProperties, style.tabs, style.numberingListIndex, style.listLevelIndex);
        this.data.charPropsExporter.exportStyleCharacterProperties(style.maskedCharacterProperties);
    };
    return ParagraphStyleExporter;
}(style_base_1.StyleBaseExporter));
exports.ParagraphStyleExporter = ParagraphStyleExporter;
